export default __webpack_public_path__ + "static/media/repliestome.7f1b2a04.png";